interface DisplayRange {
  displayStart: number;
  displayEnd: number;
}

// ページネーションの表示範囲を計算
// pageは1以上の整数
const calcDisplay = (page: number, pageSize: number, total: number): DisplayRange => ({
  displayStart: (page - 1) * pageSize + 1,
  displayEnd: Math.min(page * pageSize, total),
});

export default calcDisplay;
